// import React from 'react';
// import { Link } from 'react-router-dom';

// const Nav = () => {
//     return (
//         <div className="fixed-top loginTopBG">
//             <div className="container d-flex justify-content-between align-items-center">
//                 <div className="logo">
//                     <Link to="/">
//                         <img
//                             src="images/logo.png"
//                             className="img-fluid"
//                             alt="logo-img"
//                         />
//                     </Link>
//                 </div>
//                 <div className="accountBtn">
//                     <Link to="/login" className="btn loginBtn">LOGIN</Link>
//                     <Link to="/" className="btn regBtn">REGISTER</Link>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default Nav;


import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";

const Nav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [loginHover, setLoginHover] = useState(false);
  const [registerHover, setRegisterHover] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 992);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const styles = {
    navbar: {
      width: "100%",
      position: "fixed",
      top: 0,
      left: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: isMobile ? "16px 30px" : "18px 90px",
      background: "linear-gradient(90deg, #fff8f0 0%, #fff4ef 100%)",
      zIndex: 100,
      fontFamily: "'Montserrat', sans-serif", 
      fontSize: "15px",
      color: "#1f1f1f",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
    },

    logo: {
      width: isMobile ? "180px" : "230px",
      objectFit: "contain",
    },

    navLinks: {
      display: isMobile ? "none" : "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "45px",
      flex: 1,
      fontWeight: 500,
      color: "#2a2a2a",
    },

    navItem: {
      textDecoration: "none",
      color: "#1f1f1f",
      fontWeight: 500,
      transition: "color 0.3s ease",
      cursor: "pointer",
    },

    rightButtons: {
      display: isMobile ? "none" : "flex",
      alignItems: "center",
      gap: "10px",
    },

    loginBtn: {
      borderRadius: "200px",
      backgroundColor: loginHover ? "rgba(234, 28, 28, 0.5)" : "rgba(51, 232, 138, 0.3)",
      border: "1.5px solid rgba(79, 79, 79, 0.2)",
      padding: "12px 28px",
      fontSize: "15px",
      color: "rgba(79, 79, 79, 0.8)",
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 500,
      cursor: "pointer",
      transition: "all 0.3s ease",
      boxSizing: "border-box",
    },

    registerBtn: {
      borderRadius: "100px",
      backgroundColor: registerHover ? "#ff3c3c" : "#ff6f61",
      border: "2px solid #ff3c3c",
      padding: "12px 34px",
      fontSize: "15px",
      color: "#fff",
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 600,
      cursor: "pointer",
      boxSizing: "border-box",
      transition: "all 0.3s ease",
    },

    menuIcon: {
      display: isMobile ? "block" : "none",
      cursor: "pointer",
      fontSize: "26px",
      color: "#1f1f1f",
    },

    mobileMenu: {
      display: menuOpen && isMobile ? "flex" : "none",
      flexDirection: "column",
      position: "absolute",
      top: "100%",
      left: 0,
      width: "100%",
      background: "#fff",
      padding: "20px",
      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
      zIndex: 99,
    },

    mobileNavLinks: {
      display: "flex",
      flexDirection: "column",
      gap: "15px",
      marginBottom: "20px",
      alignItems: "center",
    },

    mobileNavItem: {
      textDecoration: "none",
      color: "#1f1f1f",
      fontWeight: 500,
      fontSize: "16px",
      transition: "color 0.3s ease",
      cursor: "pointer",
    },

    mobileButtons: {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      alignItems: "center",
    },
  };

  return (
    <div style={styles.navbar}>
      {/* Logo */}
      <Link to="/" style={{ textDecoration: "none" }}>
        <img src="images/logo.png" alt="INDmatrimony" style={styles.logo} />
      </Link>

      {/* Desktop Nav Links */}
      <div style={styles.navLinks}>
        <Link to="/about" style={styles.navItem}>
          About
        </Link>
        <Link to="/features" style={styles.navItem}>
          Feature
        </Link>
        <Link to="/success" style={styles.navItem}>
          Success Stories
        </Link>
        <Link to="/gallery" style={styles.navItem}>
          Gallery
        </Link>
      </div>

      {/* Desktop Right Buttons */}
      <div style={styles.rightButtons}>
        <Link 
          to="/otpLogin" 
          style={{ textDecoration: "none" }}
          onMouseEnter={() => setLoginHover(true)}
          onMouseLeave={() => setLoginHover(false)}
        >
          <div style={styles.loginBtn}>Login</div>
        </Link>
        <Link 
          to="/register" 
          style={{ textDecoration: "none" }}
          onMouseEnter={() => setRegisterHover(true)}
          onMouseLeave={() => setRegisterHover(false)}
        >
          <div style={styles.registerBtn}>Register</div>
        </Link>
      </div>

      {/* Hamburger Menu Icon */}
      <div style={styles.menuIcon} onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FiX size={26} /> : <FiMenu size={26} />}
      </div>

      {/* Mobile Menu Dropdown */}
      <div style={styles.mobileMenu}>
        <div style={styles.mobileNavLinks}>
          <Link to="/about ss" style={styles.mobileNavItem} onClick={() => setMenuOpen(false)}>
            About
          </Link>
          <Link to="/features" style={styles.mobileNavItem} onClick={() => setMenuOpen(false)}>
            Feature
          </Link>
          <Link to="/success" style={styles.mobileNavItem} onClick={() => setMenuOpen(false)}>
            Success Stories
          </Link>
          <Link to="/gallery" style={styles.mobileNavItem} onClick={() => setMenuOpen(false)}>
            Gallery
          </Link>
        </div>
        <div style={styles.mobileButtons}>
          <Link 
            to="/otpLogin" 
            style={{ textDecoration: "none" }}
            onClick={() => setMenuOpen(false)}
          >
            <div style={styles.loginBtn}>Login</div>
          </Link>
          <Link 
            to="/register" 
            style={{ textDecoration: "none" }}
            onClick={() => setMenuOpen(false)}
          >
            <div style={styles.registerBtn}>Register</div>
          </Link>
        </div>
      </div>
    </div>
  );
};



export default Nav;
